// extracted by mini-css-extract-plugin
module.exports = {"container":"AnswerSelect_container__XafGs","buttons":"AnswerSelect_buttons__3aJ44","button":"AnswerSelect_button__22loG"};